<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
export default {
    data() {
        return {
            showShipmentStatusDialog: false,
            id: '',
            info: {},
            types: {
                1: '实物奖品',
                2: '狮币积分',
                3: '未中奖'
            }
        };
    },
    methods: {
        init() {
            this.id = this.$route.query.id
            this.getExchangeDetail()
        },
        async getExchangeDetail() {
            this.info = await this.api.activityWinningDetail({
                access_token: localStorage.getItem("access_token"),
                id: this.id  
            })
        },
        statusChange() {
            this.getExchangeDetail()
        },
        async setStatus() {
            if(+this.info.shippingStatus === 0) {
                this.showShipmentStatusDialog = true
            }else {
                await this.$confirm('确认要取消”已发货“?', '提示', {
                    center: true,
                    showClose: true,
                    cancelButtonText: '关闭',
                    confirmButtonText: '确定'
                })

                this.activitySetShipping()
                this.$message({ type: 'success', message: '已设为"待发货"状态' })
                this.statusChange()
            }
        },
        async activitySetShipping() {
            await this.api.activitySetShipping({
                access_token: localStorage.getItem("access_token"),
                id: this.id,
                type: -1
            })
        }
    },
    created() {
        this.init()
    },
};
</script>
